import { IBookingDeliveryLocation } from '@/services/types/booking/details';
import { IQuoteDeliveryLocation } from '@/services/types/quote/IDeliveryLocation';

export const formatDeliveryLocation = (
  location: IBookingDeliveryLocation | IQuoteDeliveryLocation,
) => {
  return [
    location.street,
    location.city,
    [location.state, location.zip].filter(Boolean).join(' '),
    location.country,
  ]
    .filter(Boolean)
    .join(', ');
};
